import XQUANT_EXT_1 from "./XQUANT_EXT_1";

export default {
  XQUANT_EXT_1,
};
